import { z } from "zod";
import { NoneAuthSchema, BearerAuthSchema, HttpAuthSchema, AwsAuthSchema, ProxyAuthSchema, AllowedFormatsBase, AllowedRenderersBase, PublicationType, RendererType, AllowedRenderersBaseSet, AllowedFormatsBaseSet } from "../types";
import { AddonConfigSchema } from "../addons/schema";
import { AnyLayoutSchema } from "../layout";

export const BaseV2Schema = z.object({
  	plan: z.literal("base"),
	version: z.literal("base@2"),
	lastUpdated: z.string().datetime(),
	addons: AddonConfigSchema,
	layout: AnyLayoutSchema.default({"version":"layout@1", "regions": {}}),
	private: z.object({
		origin: z.string().optional(),
		security: z.object({
			permittedUrls: z.array(z.string()).optional(),
			requirePreAuthorisation: z.boolean().default(false),
		}).optional(),
		authentication: z.union([
			NoneAuthSchema,
			BearerAuthSchema,
			HttpAuthSchema,
			AwsAuthSchema,
			ProxyAuthSchema,
		]),
	}),
	public: z.object({
		publication: z.object({
			key: z.string().optional()
		}).optional(),
		fonts: z.object({
			name: z.literal("components.publication_default")
		}).optional(),
		settings: z.object({
			ignoreAspectRatio: z.object({
				enabled: z.boolean().default(false),
				value: z.boolean().default(false)
			}),
			fontSize: z.object({
				enabled: z.boolean().default(false),
				value: z.string().default('100%')
			}),
			fontFamily: z.object({
				enabled: z.boolean().default(false),
				value: z.string().default('components.publication_default')
			}),
		}).partial().optional(),
		languages: z.array(z.string()).optional(),
		theme: z.union([
			z.string(), // Theme as string (e.g. "dark", "modern")
			z.object({
				accent: z.string(),
				isDark: z.boolean(),
				uiBackgroundDark: z.string(),
				uiBackgroundLight: z.string(),
				uiForegroundDark: z.string(),
				uiForegroundLight: z.string(),
				highlightColor: z.string()
			}),
		]),
		formats: z.array(PublicationType)
			.default([...AllowedFormatsBase] as PublicationType[])
			.transform((formats) =>
				formats.filter(
					(r): r is (typeof AllowedFormatsBase)[number] =>
					AllowedFormatsBaseSet.has(r),
				),
		),
		renderers: z.array(RendererType)
			.default([...AllowedRenderersBase] as RendererType[])
			.transform((renderers) =>
				renderers.filter(
					(r): r is (typeof AllowedRenderersBase)[number] =>
					AllowedRenderersBaseSet.has(r),
				),
		),
	})
});

export type BaseV2 = z.infer<typeof BaseV2Schema>;